import { Controller } from "@hotwired/stimulus"
import { gsap } from "gsap"

import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);


export default class extends Controller {
  static targets = [ "announcementBar", "text"]

  initialize() {
    this.setupTl()
    window.document.querySelector('body').classList.add('announcement-bar-active')
    this.setupNavScroll()
  }

  setupNavScroll(){
    let actionNav = gsap.to('#shopify-section-header', {
      y:this.announcementBarTarget.clientHeight*-1,
      duration:.25,
      paused:true,
      ease:'linear'
    });


    ScrollTrigger.create({
      trigger: "nav",
      start:1,
      end: 9999,
      onUpdate: ({progress, direction, isActive}) => {
        if (direction == -1) {
          actionNav.reverse()
          this.startTl.play()
        } if (direction == 1 ) {
          actionNav.play()
          this.startTl.pause()
        } else if (direction == 1 && isActive == true) {
          actionNav.play()
          this.startTl.pause()
        }
      }
    });
  }

  setupTl(){
    this.startTl = gsap.timeline({
      paused: true
    })
    .fromTo(this.element.querySelector('.announcement-bar-inner'),{
      autoAlpha:0
    },{
      autoAlpha:1,
      duration:1
    })
    this.tl = gsap.timeline({
      onStart:()=>{
        this.startTl.play()
      }
    })
    .to(this.textTargets, {xPercent: -100, repeat: -1, duration: 10, ease: "linear"}).totalProgress(0.5);
    gsap.set(".announcement-bar-inner", {xPercent: -50});
  }

  pause(){
    this.tl.pause()
  }

  play(){
    this.tl.play()
  }

  disconnect(){
    // console.log('bye bye')
  }
}